import React, { PropsWithChildren } from 'react';
import { DossierValidatorsProvider } from './DossierValidatorsProvider';
import { FormalitiesProvider } from './FormalitiesProvider';
import { FormulairesProvider } from './FormulairesProvider';
import { UsersProvider } from './UsersProvider';

export type GlobalDataProviderProps = {
    formalities?: boolean;
    forms?: boolean;
    validators?: boolean;
    users?: boolean;
};

export const GlobalDataProvider: React.FunctionComponent<
    PropsWithChildren<GlobalDataProviderProps>
> = function ({ formalities = true, forms = true, validators = true, users = true, children }) {
    return (
        <DossierValidatorsProvider autoload={validators}>
            <UsersProvider autoload={users}>
                <FormalitiesProvider autoload={formalities}>
                    <FormulairesProvider autoload={forms}>{children}</FormulairesProvider>
                </FormalitiesProvider>
            </UsersProvider>
        </DossierValidatorsProvider>
    );
};
